import { connect } from 'react-redux'
import MainComponent from '../../components/employer/main.component'
import store from '../../store'
import { LOGOUT } from '../../constants/employer'
import mobileView from '../../utils/mobile.utils'

/**
 * An High order container class for the the main component.
 *
 * @author  Pragya Gupta
 *
 */

// This method will be called every time
// when the store is updated
const mapStateToProps = (state) => {
  return {
    user: state.oidc.user ? state.oidc.user : store.getState().client.user,
    navItems: navItems,
    path: state.router.location.pathname,
    lang: state.language.lang
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handleManualLogout: () => {
      dispatch({ type: LOGOUT })
    }
  }
}

// Passing the result of mapStateToProps,
// mapDispatchToProps, and the parent props
const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

// Connect does not modify the component class passed to it,
// instead it returns a new, connected component class
const MainContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MainComponent)

const navItems = [
  {
    name: 'user',
    content: 'LIGHT_ENTREPRENEURS',
    url: '/dashboard/lightEntrepreneurs'
  },
  {
    name: 'briefcase',
    content: 'ASSIGNMENTS',
    url: '/dashboard/assignments'
  },
  {
    name: 'edit',
    content: 'APPLICATIONS',
    url: '/dashboard/applications'
  },
  {
    name: 'calendar',
    content: 'WORKSHIFTS',
    url: '/dashboard/workshifts'
  }
  // {
  //   name: 'file-text',
  //   content: 'CONTRACT',
  //   url: '/dashboard/contract'
  // }
]

// For mobile views, add nav items
if (mobileView) {
  navItems.push({
    name: 'info-circle',
    content: 'PROFILE',
    url: '/dashboard/companyProfile'
  })
}

export default MainContainer
